"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Card-ProgramInsight.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Image_template = require("../../components/Image/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Image_tag = marko_loadTag(Image_template),
    Locale_template = require("../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    Button_template = require("../../components/Button/index.marko"),
    Button_tag = marko_loadTag(Button_template),
    Row_template = require("../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    WSAdapt_template = require("../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    marko_attrs0 = {
        "class": "card library-card item",
        "data-ctx-menu": "program"
      },
    marko_attrs1 = {
        "class": "card-content"
      },
    marko_attrs2 = {
        "class": "card-body"
      },
    marko_attrs3 = {
        "class": "card-title text-ellipsis-2"
      },
    marko_attrs4 = {
        "class": "card-bottom"
      },
    marko_attrs5 = {
        "class": "position-absolute top-0 left-0 m-1"
      },
    marko_attrs6 = {
        "class": "badge badge-primary"
      },
    marko_attrs7 = {
        "class": "col-5 card-like"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("6d162f"),
    marko_node0 = marko_createElement("div", {
        "class": "col-7 card-datetime text-right"
      }, "17", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("span", null, null, null, 1)
        .t("Thursday, 6 may");

function render(input, out, __component, component, state) {
  var data = input;

  WSAdapt_tag({
      ns: "col-lg-4 col-sm-6",
      qs: "col-lg-6",
      hs: "col-lg-6",
      renderBody: function(out) {
        out.be("div", marko_attrs0, "1", component);

        out.be("div", marko_attrs1, "2", component);

        route_link_tag({
            href: "/program/" + input.programId,
            renderBody: function(out) {
              Image_tag({
                  alt: input.name,
                  src: input.poster,
                  class: "card-img-top img-fluid"
                }, out, __component, "4");

              out.be("div", marko_attrs5, "5", component);

              out.be("span", marko_attrs6, "6", component);

              Locale_tag({
                  text: "Program"
                }, out, __component, "7");

              out.ee();

              out.ee();
            }
          }, out, __component, "3");

        out.be("div", marko_attrs2, "8", component);

        out.be("h4", marko_attrs3, "9", component);

        route_link_tag({
            href: "/program/" + input.programId,
            renderBody: function(out) {
              Locale_tag({
                  text: input.name,
                  class: "theme-color"
                }, out, __component, "11");
            }
          }, out, __component, "10");

        out.ee();

        out.ee();

        out.be("div", marko_attrs4, "12", component);

        Row_tag({
            class: "blue-grey-text",
            renderBody: function(out) {
              out.be("div", marko_attrs7, "14", component);

              Button_tag({
                  icon: "bx-heart",
                  activeIcon: "bx-heart",
                  class: "mx-50 font-medium-5",
                  activeClass: "mx-50 font-medium-5 text-primary"
                }, out, __component, "15");

              Button_tag({
                  icon: "bx-pin",
                  activeIcon: "bxs-pin",
                  class: "mx-50 font-medium-5",
                  activeClass: "mx-50 font-medium-5 text-primary"
                }, out, __component, "16");

              out.ee();

              out.n(marko_node0, component);
            }
          }, out, __component, "13");

        out.ee();

        out.ee();

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
